import { ChangeDetectorRef, Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagsAdvancedRuleField } from 'app/query-common/rule-interfaces/TagsAdvancedRuleField';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { Rule, RuleSet } from 'query-builder/query.interfaces';

@Component({
  selector: 'app-tags-advanced-combo-input',
  templateUrl: './tags-advanced-combo.component.html',
  styleUrls: ['./tags-advanced-combo.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TagsAdvancedComboInputComponent), multi: true },
  ]
})
export class TagsAdvancedComboInputComponent extends WithDisposableSubject()
  implements ControlValueAccessor, OnDestroy {

  @Input() targetType: 'EntityType' | 'EntityConnectionType' | 'CalendarEventType' = 'EntityType';
  @Input() campaignId: string;

  includeExcludeRules = {
    includeRule: null,
    excludeRule: null,
  };


  get value(): any {
    const transformed = {
      condition: 'and',
      ui_condition_field: 'tags_combo',
      rules: [
        this.includeExcludeRules.includeRule,
        this.includeExcludeRules.excludeRule
      ]
    };

    return transformed;
  }

  set value(value: any) {
    // noop
  }

  public onChangeCallback: () => void;
  public onTouchedCallback: () => any;

  constructor(private _cd: ChangeDetectorRef) {
    super();
  }


  writeValue(obj: RuleSet): void {
    if (obj != null) {
      this.includeExcludeRules = this.getIncludeExcludeRuleValues(obj);
      this.handleDataChange();
    }
  }

  isAny(obj: Rule) {
    return obj?.operator?.toLowerCase().includes('any');
  }

  getIncludeExcludeRuleValues(obj: RuleSet): any {
    return {
      includeRule: this.getIncludeRule(obj),
      excludeRule: this.getExcludeRule(obj)
    };
  }

  getRuleEntity(targetType) {
    switch (targetType) {
      case 'EntityConnectionType':
        return 'entity_connection';
      case 'CalendarEvent':
        return 'calendar_event_response';
      default:
        return 'entity';
    }
  }

  getIncludeRule(obj: RuleSet): TagsAdvancedRuleField {
    const rules = obj?.rules|| [];
    return (rules.find((rule: TagsAdvancedRuleField) => rule.operator?.toLowerCase().startsWith('include')) as TagsAdvancedRuleField) ||
    {
      field: 'tags_advanced',
      entity: this.getRuleEntity(this.targetType),
      operator: 'include having any',
      value: null
    };
  }

  getExcludeRule(obj: RuleSet): TagsAdvancedRuleField {
    const rules = obj?.rules|| [];
    return (rules.find((rule: TagsAdvancedRuleField) => rule.operator?.toLowerCase().startsWith('exclude')) as TagsAdvancedRuleField) ||
    {
      field: 'tags_advanced',
      entity: this.getRuleEntity(this.targetType),
      operator: 'exclude having any',
      value: null
    };
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = () => fn(this.value);
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = () => fn(this.value);
  }

  private handleDataChange(): void {
    this._cd.markForCheck();
    if (this.onChangeCallback) {
      this.onChangeCallback();
    }
  }
}
